export const QueryParameter = {
  PAGINATION: {
    PAGE: 'page',
    PAGE_ITEMS: 'page-items'
  }
};
